<template>
  <expansion-panel
    :readonly="isLoading || !assetVisit?.vehicleObservations?.length"
    :is-disabled="isLoading || !assetVisit?.vehicleObservations?.length">
    <template #title>NavTrac Details</template>
    <template #header-right>
      <span class="typography-body-sm" v-if="isPending && !assetVisit?.vehicleObservations?.length">
        {{ t('assetVisit.components.navtracObservationData.messages.scanningPending') }}
      </span>
      <div v-else>
        <span class="typography-body-sm" v-if="!assetVisit?.vehicleObservations?.length">
          {{ t('assetVisit.components.navtracObservationData.messages.noDetailsCouldBeAdded') }}
        </span>
        <span class="typography-body-sm" v-else>
          <v-icon class="mr-1">mdi-update</v-icon>
          {{ detectedAt }}
        </span>
      </div>
    </template>
    <template #content v-if="assetVisit?.vehicleObservations?.length">
      <navtrac-observation-data
        :observation-event-match-time-window="
          appointment.warehouse?.settings.observationEventMatchTimeWindow
        "
        :asset-visit="assetVisit" />
    </template>
  </expansion-panel>
</template>
<script>
import { defineComponent, ref, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import assetVisitService from '@satellite/services/asset-visit-service';
import ExpansionPanel from '@/components/elements/ExpansionPanel.vue';
import NavtracObservationData from '@/components/elements/NavtracObservationData.vue';
import { renderUtcInTimezone } from '@nova/core';
import { isObservationMatchPending } from '@/utils';

export default defineComponent({
  name: 'AppointmentDetailsGateYardNavtrac',
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  components: {
    ExpansionPanel,
    NavtracObservationData
  },
  setup(props) {
    const { t } = useI18n();

    const isLoading = ref(false);
    const assetVisit = ref(null);

    const detectedAt = computed(() => {
      return renderUtcInTimezone(
        assetVisit.value?.vehicleObservations?.[0].detectedAt,
        props.appointment.warehouse.timezone,
        'MM/DD/YYYY @ HH:mm'
      );
    });

    const isPending = computed(() =>
      isObservationMatchPending(
        assetVisit.value?.createDateTime,
        props.appointment.warehouse.settings?.observationEventMatchTimeWindow
      )
    );

    const fetchNavtracData = async () => {
      isLoading.value = true;
      try {
        const response = await assetVisitService.getAssetVisitByAppointmentId(
          props.appointment.id,
          {
            params: {
              join: ['vehicleObservations', 'vehicleObservations.assetObservations']
            }
          }
        );

        assetVisit.value = response ?? {};
      } catch (error) {
        console.error('Error fetching appointment details:', error);
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => fetchNavtracData());

    return { t, isLoading, isPending, detectedAt, assetVisit };
  }
});
</script>
